module.exports = __webpack_public_path__ + "static/media/left arrow.5300fa8e.svg";